/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateTime } from './DateTime';
import type { IntegrationMeetingParticipantResponse } from './IntegrationMeetingParticipantResponse';
export type IntegrationMeetingResponse = {
    slug: string;
    title: string;
    description: string | null;
    start: DateTime;
    end: DateTime;
    clients: Array<IntegrationMeetingParticipantResponse>;
    externalEmails: Array<string>;
    provider: IntegrationMeetingResponse.provider;
    joinUrl: string;
};
export namespace IntegrationMeetingResponse {
    export enum provider {
        ZOOM = 'zoom',
        MICROSOFT_TEAMS = 'microsoft-teams',
        TEBUTO_MEET = 'tebuto-meet',
    }
}

